export enum ReleasePriorPaymentStep {
    SecurityRequirement = 'financial-security.enrolment.release_prior_payment.security-step',
    AddBondSubmit = 'financial-security.enrolment.release_prior_payment.add-bond-submit-step',
}
